import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "product-info" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "container",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "product-info__content" })
], -1)
const _hoisted_4 = { class: "js-affix__container" }
const _hoisted_5 = { class: "container container-grid" }
const _hoisted_6 = { class: "container-grid__left product-info__left" }
const _hoisted_7 = { class: "js-affix__placeholder" }
const _hoisted_8 = { class: "product-info__sidebar js-affix" }
const _hoisted_9 = { class: "container-grid__middle container-grid__middle-and-right-md product-info__container js-tracking-download-container mt-4 mt-md-0 position-relative" }
const _hoisted_10 = ["innerHTML"]

import { onMounted, nextTick, ref, onUpdated, watch } from 'vue';
import * as lazyImg from "@elements/lazy-img";
import * as lightbox from "@elements/lightbox";
import ProductSidebar from "./ProductSidebar.vue";
import {useProductStore} from "../stores/ProductStore.ts";
import Toast from "./Toast.vue";
import * as affix from "@elements/affix";
import * as ajaxModal from '../../scripts/ajax-modal';
import {onFind} from "@elements/init-modules-in-scope";
import Tooltip from 'bootstrap/js/dist/tooltip';
import * as tracking from "@elements/tracking";
import * as priceTabs from "../../scripts/tabs";
import {on, findAll} from "@elements/dom-utils";
import {getPrefixedDataSet} from "@elements/data-set-utils";
interface Content {
    tabs: object[],
    content: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductInfo',
  props: {
    content: {},
    tree: {},
    activeTreeItem: {},
    activeTabItem: {},
    productUrl: {},
    treeUrl: {}
  },
  setup(__props: any) {

const props = __props;

let trackingOptions = {}; // optional options




const productStore = useProductStore();
const topContent = ref('');

productStore.setRequestUrls({productUrl: props.productUrl, treeUrl: props.treeUrl});
productStore.fillStore(props.tree);
productStore.setActiveTreeItem(props.activeTreeItem);
productStore.fillContent(props.content, false);
// productStore.setActiveTabItem(props.activeTabItem);

topContent.value = productStore.topContent;

onMounted(async () => {
    //history for browser back button
    window.history.replaceState(JSON.stringify({tree: productStore.tree, tabs: productStore.tabs, searchInput: productStore.searchInput, visibleItems: productStore.visibleItems, topContent: productStore.topContent, errors: productStore.errors, isFiltered: productStore.isFiltered, numberOfFilters: productStore.numberOfFilters, activeTreeItem: productStore.activeTreeItem, activeTabItem: productStore.activeTabItem}), "");
    await nextTick(function(){
        lazyImg.init();
        ajaxModal.init();
        priceTabs.init();
        tracking.initGtmEventTracking(trackingOptions); // for GTM tracking
        //ts-ignore
        affix.init({
            offset: 180,
            mediaQuery: '(min-width: 768px)',
        });
        onFind('[data-bs-toggle="tooltip"]', (element) => {
            console.log('tooltip');
            new Tooltip(element);
        });
    });
});

watch( () => productStore.topContent, (newValue, oldValue) => {
    updateTopContent();
});

async function updateTopContent(){
    await nextTick();
    lazyImg.init();
    tracking.initGtmEventTracking(trackingOptions); // for GTM tracking
    priceTabs.init();
    onFind('[data-bs-toggle="tooltip"]', (element) => {
        console.log('tooltip');
        new Tooltip(element);
    });
}

watch(() => productStore.activeTabItem, (newValue, oldValue) => {
    updateActiveTabItem();
});

async function updateActiveTabItem(){
    await nextTick();
    lazyImg.init();
    lightbox.init();
    ajaxModal.init();
    scrollToTop();
    priceTabs.init();
    tracking.initGtmEventTracking(trackingOptions); // for GTM tracking
    onFind('[data-bs-toggle="tooltip"]', (element) => {
        console.log('tooltip');
        new Tooltip(element);
    });
}

const scrollToTop = () => {
    if(matchMedia('(min-width: 768px)').matches){
        const productInfo = document.querySelector('.product-info');
        if(productInfo){
            const offset = productInfo.getBoundingClientRect().top + window.scrollY - 160;
            window.scrollTo({top: offset, behavior: 'smooth'});
        }
    }
}

//when browser back button is clicked
window.addEventListener("popstate", function(e) {
    if(e.state){
        let state = JSON.parse(e.state);
        productStore.tree = state.tree;
        productStore.tabs = state.tabs;
        productStore.searchInput = state.searchInput;
        productStore.visibleItems = state.visibleItems;
        productStore.topContent = state.topContent;
        productStore.errors = state.errors;
        productStore.isFiltered = state.isFiltered;
        productStore.numberOfFilters = state.numberOfFilters;
        productStore.activeTreeItem = state.activeTreeItem;
        productStore.activeTabItem = state.activeTabItem;
    }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_unref(productStore).topContent)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              innerHTML: _unref(productStore).topContent
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(ProductSidebar, {
                tree: _ctx.tree,
                tabs: _ctx.content.tabs
              }, null, 8, ["tree", "tabs"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_Transition, {
            name: "fade",
            class: "w-100"
          }, {
            default: _withCtx(() => [
              (_unref(productStore).tabs.length !== 0)
                ? (_openBlock(), _createElementBlock("div", {
                    key: _unref(productStore).activeTabItem,
                    innerHTML: _unref(productStore).getContentFromActiveTab
                  }, null, 8, _hoisted_10))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(Toast)
  ]))
}
}

})